module.exports = __webpack_public_path__ + "media/site_templates/www.removingasbestos.net.au/images/our_services_2-18457ea8d677b5d8d25e6043ced32030.jpg";